export const SITE = 'https://fallowbuildingservices.co.uk';
export const BUSINESS_ID = `${SITE}/#business`;
export const BUSINESS_NAME = 'Fallow Building Services';
export const LEGAL_NAME = 'Fallow Business Group Ltd';
export const PHONE = '02035765962';
export const PHONE_DISPLAY = '0203 576 5962';
export const EMAIL = 'info@fallowbuildingservices.co.uk';
export const WHATSAPP = 'https://wa.me/447459627464';
export const BARK = 'https://www.bark.com/en/gb/company/fallow-building-services/Gw6Nv/';
export const OG_IMAGE = `${SITE}/images/hero-construction.jpg`;

export const ADDRESS = {
  '@type': 'PostalAddress',
  streetAddress: '6 Sunningdale Road',
  addressLocality: 'Rainham',
  addressRegion: 'Essex',
  postalCode: 'RM13 7BD',
  addressCountry: 'GB',
};

export const AREAS = [
  'Romford',
  'Hornchurch',
  'Rainham',
  'Upminster',
  'Gidea Park',
  'Harold Hill',
  'Barking',
  'Dagenham',
  'Redbridge',
];

export function businessSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'HomeAndConstructionBusiness',
    '@id': BUSINESS_ID,
    name: BUSINESS_NAME,
    legalName: LEGAL_NAME,
    image: `${SITE}/images/logo-large.png`,
    description:
      'Building contractor in Rainham, Havering. Extensions, loft conversions, renovations, roofing and property maintenance.',
    url: SITE,
    telephone: PHONE,
    email: EMAIL,
    priceRange: '££',
    address: ADDRESS,
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 51.5144,
      longitude: 0.1849,
    },
    areaServed: AREAS.map((name) => ({ '@type': 'Place', name })),
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '08:00',
        closes: '18:00',
      },
    ],
    sameAs: [BARK],
    identifier: {
      '@type': 'PropertyValue',
      name: 'Companies House',
      value: '16532814',
    },
  };
}

export function breadcrumbSchema(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.path === '/' ? `${SITE}/` : `${SITE}${item.path}`,
    })),
  };
}

export function serviceSchema({ name, description, path }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name,
    description,
    url: `${SITE}${path}`,
    areaServed: AREAS.map((area) => ({ '@type': 'Place', name: area })),
    provider: { '@id': BUSINESS_ID },
  };
}

export function faqSchema(faqs) {
  if (!faqs || faqs.length === 0) return null;
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}

export function graph(nodes) {
  return {
    '@context': 'https://schema.org',
    '@graph': nodes.filter(Boolean).map((node) => {
      const copy = { ...node };
      delete copy['@context'];
      return copy;
    }),
  };
}
